const preload = (imageSrc: string): Promise<void> =>
  new Promise(async (resolve, reject) => {
    const request = new Request(imageSrc);

    try {
      const response = await fetch(request);
      if (!response.ok) {
        reject();
        throw new Error(`HTTP error! Status: ${response.status}`);
      } else {
        resolve();
      }
    } catch (err: any) {
      reject();
      throw new Error('HTTP error!', err);
    }
  });

const preloadAll = (imageSrcs: string[]) => Promise.all(imageSrcs.map(preload));

export const ImageUtil = {
  preloadAll,
};
